import axios from '@axios'

const PREFIX = '/assinatura-documento'

export default {

  getLinkAutenticacao() {
    return axios.get(`${PREFIX}/link-autenticacao`)
  },

  enviarAssinatura(id) {
    return axios.post(`${PREFIX}/documento/enviar-para-assinar/${id}`)
  },

  getArquivoContrato(id, externo = false) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-propostas/contrato-arquivo/${id}?externo=${externo}`)
    }
    return axios.get(`${PREFIX}/contrato-arquivo/${id}?externo=${externo}`)
  },

  enviarContratoAtualizado(id, alteracao = false) {
    return axios.post(`${PREFIX}/envia-contrato-atualizado/${id}?alteracao=${alteracao}`)
  },

  deletarArquivo(fileName, externo = false) {
    if (externo) {
      return axios.delete(`${PREFIX}/portal-propostas/arquivo?filename=${fileName}`)
    }
    return axios.delete(`${PREFIX}/arquivo?filename=${fileName}`)
  },
}
